import { provideLocal, injectLocal } from '@vueuse/core';
import useProcessImages from './useProcessImages';

const IMAGE_CAROUSEL_REPOSITORY = Symbol.for('IMAGE_CAROUSEL_REPOSITORY');

export function useImagesProvide() {
  const toProvide = useProcessImages();
  provideLocal(IMAGE_CAROUSEL_REPOSITORY, toProvide);
  return toProvide;
}

export default function useImages(): ReturnType<typeof useImagesProvide> {
  const images: ReturnType<typeof useImagesProvide> | undefined = injectLocal(IMAGE_CAROUSEL_REPOSITORY);
  if (typeof images === 'undefined') {
    throw new TypeError('useImages() is called without provider.');
  }
  return images;
}
